import { useState } from "react";
import { messages } from "../config/messages";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { FormControl, FormLabel, RadioGroup, Button, FormControlLabel, Box, Alert, Typography, Radio, Modal, FormHelperText, IconButton } from "@mui/material";

const YesNoFieldWithAlert = ({ label, value, onChange, required, helperText, yesLabel, noLabel }) => {
  const handleChange = (event) => {
    const val = event.target.value;

    if (val === "true") onChange(true);
    else if (val === "false") onChange(false);
    else onChange(null);
  };
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };

  return (<>
    <FormControl sx={{
      padding: 2,
      backgroundColor: "#eef2f6",
      borderRadius: 4,
    }}>
      <FormLabel required={required}>{label}</FormLabel>

      <RadioGroup
        // row
        value={
          value === true ? "true" :
            value === false ? "false" :
              ""
        }
        onChange={handleChange}

      >
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <FormControlLabel value="true" control={<Radio />} label={yesLabel} />
          <IconButton
            size="small"
            aria-label="More info about Yes"
            onClick={handleOpen}
          >
            <InfoOutlinedIcon fontSize="inherit" />
          </IconButton>
        </Box>
        <FormControlLabel value="false" control={<Radio />} label={noLabel} />
        <FormHelperText id="my-helper-text">{helperText}</FormHelperText>
      </RadioGroup>
    </FormControl>
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="more-info-text"
      aria-describedby="more-info-description"
    >
      <Box sx={{...style, width: 400 }}>
        <Alert severity="info" variant="outlined">
          <Typography
            variant="body2"
            dangerouslySetInnerHTML={{ __html: messages.eucontroledSecondNote }}
          />
        </Alert>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            mt: 2,
          }}
        >
          <Button variant="contained" onClick={handleClose}>
            {messages.close}
          </Button>
        </Box>
      </Box>
    </Modal>

  </>
  );
};

export default YesNoFieldWithAlert;